import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import PDPAvailableInSizesListItem from './PDPAvailableInSizesListItem';
const PDPAvailableInSizesRowUI = t0 => {
  const $ = _c(12);
  const {
    dimensions,
    id,
    image,
    isActive,
    loading,
    name,
    price,
    urlKey,
    productsData: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const productsData = t2;
  if (loading) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div><Placeholder type="rect" loading={true} style={{
          height: 72
        }} /></div>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  if (!id || !name) {
    return null;
  }
  let t3;
  if ($[3] !== dimensions || $[4] !== id || $[5] !== image || $[6] !== isActive || $[7] !== name || $[8] !== price || $[9] !== productsData || $[10] !== urlKey) {
    t3 = <div><PDPAvailableInSizesListItem {...{
        id,
        name,
        price,
        dimensions,
        image,
        isActive,
        urlKey,
        productsData
      }} /></div>;
    $[3] = dimensions;
    $[4] = id;
    $[5] = image;
    $[6] = isActive;
    $[7] = name;
    $[8] = price;
    $[9] = productsData;
    $[10] = urlKey;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
PDPAvailableInSizesRowUI.propTypes = {
  dimensions: PropTypes.string,
  id: PropTypes.number,
  image: PropTypes.string,
  isActive: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.number,
  productsData: PropTypes.arrayOf(PropTypes.object),
  urlKey: PropTypes.string
};
export default PDPAvailableInSizesRowUI;